import React, { Component } from 'react';
import Loader from '../../components/Loader';
import Header from '../../components/Header';
import MetricChart from '../../components/MetricChart';

import './MetricsPage.css';

export default class MetricsPage extends Component {

  constructor(){
    super();
    window.page = this;
  }

  render() {
    return (
      <div className="metrics-page">
        <Loader />
        <Header />
        <div className="pad20">
          <MetricChart/>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/routes/analytics/MetricsPage.js